"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatList = exports.formatPhoneNumber = exports.formatQuantity = exports.formatPercent = exports.formatFuzzy = exports.customCurrencyFormat = exports.formatCurrency = void 0;
function formatCurrency(x) {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    return formatter.format(x);
}
exports.formatCurrency = formatCurrency;
function customCurrencyFormat(value) {
    if (value < 1 && value > -1) {
        return `$${value.toPrecision(2)}`;
    }
    return formatCurrency(value);
}
exports.customCurrencyFormat = customCurrencyFormat;
function formatFuzzy(value) {
    const scaledUnits = [
        { unit: "", divisor: 1.0, max: 250000 },
        { unit: "M", divisor: 1e6, max: 1e9 },
        { unit: "B", divisor: 1e9, max: 1e12 },
        { unit: "T", divisor: 1e12, max: Number.MAX_VALUE },
    ];
    const absValue = Math.abs(value);
    const unit = scaledUnits.find((unit) => absValue <= unit.max) ||
        scaledUnits[scaledUnits.length - 1];
    const scaledValue = value / unit.divisor;
    return `${formatCurrency(scaledValue)}${unit.unit}`;
}
exports.formatFuzzy = formatFuzzy;
function formatPercent(x) {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "percent",
        maximumSignificantDigits: 3,
    });
    return formatter.format(x);
}
exports.formatPercent = formatPercent;
function formatQuantity(x) {
    const formatter = new Intl.NumberFormat("en-US", {
        maximumSignificantDigits: 3,
    });
    return formatter.format(x);
}
exports.formatQuantity = formatQuantity;
function formatPhoneNumber(phone) {
    if (phone.length === 10) {
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }
    return phone;
}
exports.formatPhoneNumber = formatPhoneNumber;
function formatList(list, finalSymbol = " & ") {
    if (list && list.length > 0) {
        if (list.length === 1) {
            return list[0];
        }
        return [
            list.slice(0, list.length - 1).join(", "),
            list[list.length - 1],
        ].join(finalSymbol);
    }
    return "";
}
exports.formatList = formatList;
//# sourceMappingURL=formats.js.map